module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "Chapter-Name-1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 1: Our Best Advice")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 2: Must-Haves")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 3: Pregnancy")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 4: Is It Labor or Bad Food?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 5: Packing for the Hospital")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 6: You Try Pushing Out a Watermelon!")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 7: Postpartum Fun")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 8: The Mom Diaper")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 9: Bringing Baby Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 10: Why Do I Feel This Way?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 11: Bonding")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 12: The Joy of Breasts")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 13: It’s Feeding Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 14: Sexy Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 15: I Changed It Last Time, It’s Your Turn")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 16: It’s So Cute! How Do You Put It On?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 17: Does It Ever Stop Crying?!")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 18: Shh . . . Baby Is Sleeping")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 19: Just for Dad")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 20: Raising ’Em Solo")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 21: Bonus Parents Caveat to the Following Two Chapters")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 22: Boys! Just Like Girls, but Harder to Keep Alive")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Chapter 23: Girls! Delicate like . . . a Bomb")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("A Final Note to the Reader")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/c25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Works Cited")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body-NI ParaOverride-67"
  }, [_c('span', {
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0